import React from "react";
import HomePage from "./pages/homePage";

const App = () => {
  return <HomePage />;
};

export default App;
